import { useFundListSuspense } from "gen/endpoints/fund-entities/fund-entities";

export const useEntityName = (fundFamilyId: string, entityId: string) => {
  const { data } = useFundListSuspense({
    fund_family_ids: [fundFamilyId],
  });
  return data.find((it) => it.id === entityId)?.legal_name;
};
